import { computed, readonly, ref } from "vue";

import { authApi, type SessionPayload } from "@/api/auth";

const session = ref<SessionPayload | null>(null);
const loading = ref(false);
let pending: Promise<SessionPayload> | null = null;

async function load(): Promise<SessionPayload> {
  if (session.value) return session.value;
  if (pending) return pending;
  loading.value = true;
  pending = authApi.session().then((value) => {
    session.value = value;
    return value;
  });
  try {
    return await pending;
  } finally {
    pending = null;
    loading.value = false;
  }
}

async function login(email: string, password: string) {
  session.value = await authApi.login(email, password);
  return session.value;
}

async function logout() {
  await authApi.logout();
  session.value = await authApi.session();
}

export function useSession() {
  return {
    session: readonly(session),
    loading: readonly(loading),
    authenticated: computed(() => session.value?.authenticated === true),
    load,
    login,
    logout,
  };
}

export function resetSessionForTests() {
  session.value = null;
  pending = null;
}
